import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Slider from '@react-native-community/slider';
import FontSizes from '../../../../constants/FontSizes';
import { MainColors } from '../../../../constants/Colors';

const SliderControl = (props) => {
    return (
        <View style={styles.container}>
            <Text style={styles.headerLabel}>{props.headerLabel}</Text>
            <Text style={styles.valueLabel}>{props.valueLabel}%</Text>
            <Slider
                style={styles.slider}
                disabled={props.disabled}
                minimumValue={0}
                maximumValue={100}
                minimumTrackTintColor={MainColors.primary}
                maximumTrackTintColor={MainColors.lightGray}
                thumbTintColor={MainColors.primary}
                step={1}
                value={props.value}
                onValueChange={props.onValueChange}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 20
    },
    headerLabel: {
        paddingLeft: 12,
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium,
        fontWeight: '500'
    },
    valueLabel: {
        textAlign: 'right',
        marginRight: 10,
        color: MainColors.darkGray,
        fontWeight: '500',
        fontSize: FontSizes.medium
    },
    slider: {
        width: '100%',
        height: 30,
        alignSelf: 'center'
    }
});

export default SliderControl;